import * as React from "react";

import DocListItem from "./ListItem";

interface DocNumberedListProps extends NumberedListNode, EveryNodeArgs {}

export default function DocNumberedList(props: DocNumberedListProps) {
  const listItems = props.content.map((listItem) => {
    return (
      <DocListItem
        key={listItem.uid}
        {...listItem}
        currentDocument={props.currentDocument}
        currentVersion={props.currentVersion}
        currentRoleDefinition={props.currentRoleDefinition}
        currentDocumentSetDocumentRelation={props.currentDocumentSetDocumentRelation}
        currentUser={props.currentUser}
        displayState={props.displayState}
        editState={props.editState}

        isGated={props.isGated}
      />
    );
  });

  return (
    <ol className="doc-numbered-list">
      {listItems}
    </ol>
  );
}
